import { forwardRef, Textarea, TextareaProps } from "@chakra-ui/react";
import { FormField, FormFieldProps } from "./field";
import { makeFormInputDefaultProps } from "./styles";

export interface FormTextAreaProps extends TextareaProps {
  name: string;
  formName: string;
  label?: string;
  placeholder?: string;
  required: boolean;
  controlSx?: Omit<FormFieldProps, "isRequired">;
}

export const FormTextArea = forwardRef(
  (
    {
      name,
      formName,
      label,
      placeholder,
      required,
      controlSx,
      ...rest
    }: FormTextAreaProps,
    ref: any,
  ) => {
    return (
      <FormField
        {...controlSx}
        isRequired={required || false}
        label={label}
        labelSx={{
          htmlFor: formName,
          ...controlSx?.labelSx,
        }}
      >
        <Textarea
          {...makeFormInputDefaultProps(rest?.focusBorderColor)}
          {...rest}
          ref={ref}
          id={formName}
          name={formName}
          placeholder={placeholder}
        />
      </FormField>
    );
  },
);
